const modals = {
  orderNoticeKey: 1,
  orderNoticeAlreadyCount: 0, //已发货数量
  orderNoticeCompleteCount: 0, //已完成数量
  orderNoticeTodoCount: 0, //待发货数量
  orderNoticeUndoCount: 0, //已取消数量
  orderNoticeList: null, //table数据
  orderNoticeCurrent: null, //
  orderNoticeSize: null, //
  orderNoticeTotal: null, //
  exportLoading: false, // 导出loading
  orderNoticeId: [], //当前选择的id
  selectedRowKeys: [],
  orderNoticeSerchParameters: {},
  isSendFlag: null, //发货是否成功
  isSendMsg: null, //发货失败信息
  printListDatas: [], //批量打印数据
  reseverSelectRows: [],
  isVisivleReseverFlag: false,
  timeIntervalData: [],
  checkedTimeRange: '',
  exportCustormsLoading: false,
  selected: [],
};

export default modals;
